var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-button',{staticClass:"export-file-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.exportXls.apply(null, arguments)}}},[_c('i',{staticClass:"icofont-file-excel"}),_vm._v(" "+_vm._s(_vm.label)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }